import { useMyMonitoringGetSiteStats } from '@apps-common/apis/my-monitoring/site'
import { SiteManageCardItem } from '@apps-common/apps/my-monitoring/pages/site/components/site-manage'
import { UnitControls, UnitManageCardSkeleton } from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { commonIcons } from '@apps-common/config/icons'
import { IMMSiteModel } from '@apps-common/types/my-monitoring'
import { ROUTE_UNIT_SCHEDULES, ROUTE_UNIT_TRIGGERS, ROUTE_UNIT_USERS, ROUTE_UNIT_ZONES } from '@apps-radionet-portal/config/private-routes'

import { useMyMonitoringSiteContextStore } from '@apps-common/stores'
import { useEffect } from 'react'
import { SiteManageSchedulesModal, SiteManageTriggersModal, SiteManageUsersModal, SiteManageZonesModal } from './modals'

interface IProps {
  layoutPrefix: string
  siteLoading?: boolean
  site?: IMMSiteModel
  setView: (key: string) => void
  registerRefetch: (caller: { id: string; refetch: () => void }) => void
}

export const SiteManageMyMonitoringContainer: React.FC<IProps> = ({ layoutPrefix, siteLoading, site, setView, registerRefetch }) => {
  const { isAdmin } = useMyMonitoringSiteContextStore()

  const { isLoading, isFetching, data, refetch } = useMyMonitoringGetSiteStats({
    config: {
      enabled: !!site
    },
    unitId: site?.unitId
  })

  useEffect(() => {
    registerRefetch({ id: 'siteManageMyMonitoring', refetch })
  }, [])

  const UNIT_DETAILS_KPI_MAP = [
    {
      keys: ['myMonitoringUsers', 'namedUsers'],
      viewKey: 'users',
      label: 'Users',
      Icon: commonIcons.users,
      route: ROUTE_UNIT_USERS,
      Modal: SiteManageUsersModal
    },
    {
      keys: ['customZones'],
      viewKey: 'zones',
      label: 'Zones',
      Icon: commonIcons.zones,
      route: ROUTE_UNIT_ZONES,
      Modal: SiteManageZonesModal
    },
    {
      keys: ['schedules'],
      viewKey: 'schedules',
      label: 'Schedules',
      Icon: commonIcons.schedule,
      route: ROUTE_UNIT_SCHEDULES,
      Modal: SiteManageSchedulesModal
    },
    {
      keys: ['triggers'],
      viewKey: 'triggers',
      label: 'Triggers',
      Icon: commonIcons.trigger,
      route: ROUTE_UNIT_TRIGGERS,
      Modal: SiteManageTriggersModal
    }
  ]

  const loading = !site || siteLoading || isLoading || isFetching || !data

  return (
    <div>
      <div className='grid grid-cols-3 sm:grid-cols-3 gap-[10px] md:gap-[15px]'>
        {loading && UNIT_DETAILS_KPI_MAP.map((k, i) => <UnitManageCardSkeleton key={`unit-manage-card-skeleton-${i}`} />)}
        {!loading && site && (
          <>
            {UNIT_DETAILS_KPI_MAP.map((k, i) => {
              const value = k.keys.reduce((acc, key) => {
                const num = (data as any)[key]

                if (typeof num === 'number') {
                  return acc + num
                }

                return acc
              }, 0)

              return (
                <SiteManageCardItem
                  key={`site-manage-card-outer-${i}`}
                  index={i}
                  unitId={site?.unitId}
                  count={value}
                  label={k.label}
                  Icon={k.Icon}
                  callback={() => setView(k.viewKey)}
                />
              )
            })}
          </>
        )}
        <div className='col-span-2'>
          <UnitControls
            loading={loading}
            layoutPrefix={layoutPrefix}
            unitId={site?.unitId}
            isActivated
            registerRefetch={registerRefetch}
            showDefaultControlOptions
            hideCreate={!isAdmin}
          />
        </div>
      </div>
    </div>
  )
}
